<template>
    <div v-if="shouldShowReconnectBtn || debugForceShow" class="websocket-button-background">
        <div class="offline-status-container flex-col" @click="reloadPage">
            <div class="offline-content flex-row w-100">
                <div class="offline-icon-pulse">
                    <i class="ri-alarm-warning-line"></i>
                </div>
                <div class="offline-text">
                    <strong>Websocket Desconectado </strong>
                    <span>Clique para recarregar.</span>
                </div>
                <!-- <button class="btn btn-reconnect d-flex flex-row justify-content-center square-40 p-2" @click.stop="reloadPage" v-tooltip="'Recarregar'">
                    <i class="ri-loop-right-fill"></i>
                </button> -->
            </div>
            <!-- <div class="d-flex flex-row">
                <div class="offline-text">
                    <span>É possível que o recebimento de mensagens esteja incompleto.</span>
                </div>
            </div> -->
        </div>
    </div>
    <!-- <div class="p-6">
        <button class="bg-blue-500 rounded-lg px-6 py-3 leading-none text-white uppercase font-semibold text-sm shadow-sm hover:shadow-lg transition-all duration-200 transform hover:-translate-y-0.5">Sign up</button>
    </div> -->
</template>
<script setup lang="ts">
import { ref } from 'vue';

defineProps({
    shouldShowReconnectBtn: { type: Boolean, required: true }
})

const debugForceShow = ref(false);

function reloadPage() {
    window.location.reload();
}

</script>
<style scoped>
.square-40 {
    width: 40px;
    height: 40px;
}

.websocket-button-background {
    width: 100%;
    height: fit-content;
    border-radius: 12px;
    background: var(--bs-sidebar-sub-bg);
}

/* Estilo para o aviso de Inbox Desconectada */
.offline-status-container {
    background: rgba(239, 161, 71, 0.1);
    border: 2px dashed #efa147b3;
    border-radius: 12px;
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.2s ease;
}

.offline-status-container:hover {
    background: rgba(239, 161, 71, 0.15);
    transform: translateY(-2px);
    border-style: solid;
}

.offline-content {
    display: flex;
    align-items: center;
    gap: 15px;
}

.offline-icon-pulse {
    width: 45px;
    height: 45px;
    background-color: #efa147b3;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    animation: pulse-red 2s infinite;

    flex-shrink: 0;
}

.offline-text {
    display: flex;
    flex-direction: column;
}

.offline-text strong {
    color: #efa147b3;
    font-size: 16px;
}

.offline-text span {
    font-size: 13px;
    color: var(--bs-text-muted);
}

.btn-reconnect {
    background-color: #efa147b3;
    color: white;
    border-radius: 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background 0.2s;

    flex-shrink: 0 !important;
    white-space: nowrap !important;
}

.btn-reconnect:hover {
    background-color: #efa147d2;
    color: white;
}

@keyframes pulse-red {
    0% { box-shadow: 0 0 0 0 rgba(239, 161, 71, 0.7); }
    70% { box-shadow: 0 0 0 10px rgba(239, 161, 71, 0); }
    100% { box-shadow: 0 0 0 0 rgba(239, 161, 71, 0); }
}
</style>